import { Link } from 'react-router-dom';
import { PageMeta, JsonLd } from '@/components/feature/SeoComponents';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于老子影视网',
  description: '老子影视网是一个专注于电视剧大全在线播放的平台，提供国产剧全集、韩剧全集、最新电视剧免费高清在线观看服务。',
  url: 'https://www.laoziys.com/about',
  isPartOf: {
    '@type': 'WebSite',
    name: '老子影视网',
    url: 'https://www.laoziys.com',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.laoziys.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://www.laoziys.com/about',
      },
    ],
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '老子影视网的电视剧资源需要付费吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '老子影视网所有电视剧资源均免费在线观看，无需付费或会员注册。我们致力于为追剧爱好者提供最便捷的观影体验。',
      },
    },
    {
      '@type': 'Question',
      name: '老子影视网支持哪些设备观看？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '老子影视网支持电脑、平板、手机等所有主流设备在线观看，无需下载任何播放器或APP，打开浏览器即可畅享高清画质。',
      },
    },
    {
      '@type': 'Question',
      name: '老子影视网的电视剧更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '老子影视网每日更新最新电视剧资源，热门剧集同步更新，确保追剧用户第一时间观看到最新剧集内容。',
      },
    },
    {
      '@type': 'Question',
      name: '电视剧播放卡顿怎么办？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '老子影视网采用先进的视频加速技术，确保高清画质不缓冲。如遇卡顿，请检查网络连接或切换清晰度。',
      },
    },
    {
      '@type': 'Question',
      name: '如何搜索想看的电视剧？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过首页顶部的搜索框输入电视剧名称进行搜索，也可以按国产剧、韩剧、美剧等分类浏览查找。',
      },
    },
  ],
};

export default function AboutPage() {
  return (
    <>
      <PageMeta
        title="关于我们 | 老子影视网 - 电视剧大全 免费在线观看"
        description="老子影视网品牌介绍，专注电视剧大全在线播放，国产剧全集、韩剧全集免费高清在线观看，了解我们的品牌故事与联系方式。"
        keywords="老子影视网,关于我们,品牌介绍,联系方式,电视剧在线,免费观看"
        canonicalUrl="https://www.laoziys.com/about"
      />
      <JsonLd data={aboutJsonLd} />
      <JsonLd data={faqJsonLd} />

      <main className="pt-20">
        <nav className="w-full px-4 md:px-6 py-4" aria-label="Breadcrumb">
          <ol className="flex items-center gap-2 text-sm text-foreground-500">
            <li><Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li className="text-foreground-900 font-medium">关于我们</li>
          </ol>
        </nav>

        <section className="w-full px-4 md:px-6 py-10 md:py-16">
          <div className="text-center mb-12">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-500 rounded-2xl">
              <i className="ri-movie-2-line text-3xl text-white"></i>
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
              关于老子影视网
            </h1>
            <p className="text-foreground-500 max-w-2xl mx-auto text-sm md:text-base">
              追剧不等待，精彩不打烊。老子影视网，你的专属追剧伙伴。
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-2">
              <i className="ri-building-4-line text-primary-500"></i>
              品牌介绍
            </h2>
            <div className="space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                <strong className="text-foreground-900">老子影视网</strong>成立于2020年，是一个专注于<strong>电视剧大全在线播放</strong>的综合性影视平台。我们致力于为广大追剧爱好者提供<strong>最新电视剧</strong>、<strong>国产剧全集</strong>、<strong>韩剧全集</strong>等优质内容的免费在线观看服务。
              </p>
              <p>
                平台汇聚了来自中国大陆、韩国、日本、美国、台湾、泰国等多个国家和地区的精品电视剧资源，涵盖古装仙侠、都市爱情、悬疑刑侦、科幻奇幻等多种题材类型。无论你是喜欢国产正剧的深度内涵，还是钟情于韩剧的情感细腻，老子影视网都能满足你的追剧需求。
              </p>
              <p>
                我们持续优化播放技术，采用先进的视频加速方案，确保<strong>高清画质不缓冲</strong>，让每一位用户都能享受到流畅的观影体验。同时，平台每日更新最新剧集资源，让你不错过任何一部热门好剧。
              </p>
              <p>
                老子影视网始终秉持"<strong>追剧不等待，精彩不打烊</strong>"的理念，用心打造一个纯粹、便捷、高品质的电视剧在线播放平台。无需注册登录，无需付费订阅，打开浏览器即可畅享万千精彩剧集。
              </p>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-2">
              <i className="ri-thumb-up-line text-accent-500"></i>
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  rating: 5,
                  text: '追剧追了好几年了，老子影视网是我用过的更新最快、画质最清晰的平台。国产剧韩剧资源都很全，强烈推荐！',
                  author: '追剧达人小王',
                },
                {
                  rating: 5,
                  text: '不用注册就能看，太方便了。高清不卡顿，每天晚上都泡在老子影视网上面追剧，已经离不开了。',
                  author: '夜猫子追剧人',
                },
                {
                  rating: 5,
                  text: '韩剧资源真的全，很多冷门好剧都能找到。分类清楚，搜索方便，界面简洁好看，五星好评！',
                  author: '韩剧发烧友',
                },
                {
                  rating: 4,
                  text: '一直在用老子影视网追剧，整体体验很好。国产剧更新速度很快，基本和卫视同步，赞一个！',
                  author: '剧荒终结者',
                },
                {
                  rating: 5,
                  text: '朋友推荐的，用了一次就爱上了。资源齐全，播放流畅，而且完全免费，真的是良心平台。',
                  author: '追剧小达人',
                },
                {
                  rating: 5,
                  text: '界面设计简洁大方，分类导航清晰，找剧很方便。高清画质不缓冲这个确实做到了，体验很棒。',
                  author: '影视爱好者老张',
                },
              ].map((review, idx) => (
                <div
                  key={idx}
                  className="bg-background-100 rounded-xl p-5 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }, (_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "{review.text}"
                  </blockquote>
                  <cite className="text-xs text-foreground-500 not-italic">
                    — {review.author}
                  </cite>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-2">
              <i className="ri-mail-line text-primary-500"></i>
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-mail-send-line text-lg"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">商务合作</h3>
                <p className="text-sm text-foreground-600">
                  如有商务合作需求，请发送邮件至：
                  <br />
                  <a href="mailto:business@laoziys.com" className="text-primary-600 hover:text-primary-700 font-medium">business@laoziys.com</a>
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                  <i className="ri-question-answer-line text-lg"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">用户反馈</h3>
                <p className="text-sm text-foreground-600">
                  遇到问题或有建议？欢迎反馈：
                  <br />
                  <a href="mailto:feedback@laoziys.com" className="text-accent-600 hover:text-accent-700 font-medium">feedback@laoziys.com</a>
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-4">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">微信公众号</h3>
                <p className="text-sm text-foreground-600">
                  关注微信公众号获取最新剧集推荐：
                  <br />
                  <span className="font-medium text-foreground-800">老子影视网</span>
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-weibo-line text-lg"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">官方微博</h3>
                <p className="text-sm text-foreground-600">
                  关注微博获取最新动态：
                  <br />
                  <a href="#" className="text-primary-600 hover:text-primary-700 font-medium">@老子影视网官方</a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}